import { render } from "./Courses.vue?vue&type=template&id=7c0cdbcd"
import script from "./Courses.vue?vue&type=script&lang=js"
export * from "./Courses.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/codehat-academy-front-vue3/codehat-academy-front-vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__